import { css } from "@emotion/react";
import React, { forwardRef } from "react";

export const FormControl = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  return (
    <div
      css={css({
        position: "relative",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        border: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      })}
      {...props}
      ref={ref}
    />
  );
});
